import TermBox from './TermBox'
import './term-box.scss'

export default TermBox
